import React from 'react';
import PlaceholderLoader from '../../PlaceholderLoader';
import { useParkingLot } from '@debbie/cortex/dist/bespoke/apcoa';
import { h } from '@debbie/cortex/dist';
import THEME from '../../../theme';
import Alert from '../../Alert';
import PowerTable, { FilterType } from '../../PowerTable';
const DPT = (props) => {
    const { parkingLotCode } = props;
    const parkingLotLoadable = useParkingLot(parkingLotCode);
    const parkingLot = h.isLoaded(parkingLotLoadable)
        ? parkingLotLoadable.data
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            h.isError(parkingLotLoadable) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            parkingLot ? (React.createElement(PowerTable, { data: parkingLot.DPT.sort((a, b) => a.Line_No - b.Line_No).map((dpt) => ({
                    comment: dpt.Comment,
                    lineNo: dpt.Line_No,
                    startingDate: dpt.Starting_Date,
                    endingDate: dpt.Ending_Date,
                    solutionType: dpt.Solution_Type,
                    kind: dpt.Kind,
                })), genKey: (dpt) => JSON.stringify(dpt), pagination: {
                    type: 'none',
                    pageSize: parkingLot.DPT.length,
                }, values: {
                    startingDate: {
                        label: 'Startdato',
                        toCmp: (startingDate) => startingDate,
                        map: (startingDate) => {
                            return React.createElement("div", null, startingDate);
                        },
                        filter: {
                            type: FilterType.DateRange,
                        },
                    },
                    endingDate: {
                        label: 'Slutdato',
                        toCmp: (endingDate) => endingDate,
                        map: (endingDate) => {
                            return (React.createElement("div", null, !endingDate || endingDate === '0001-01-01'
                                ? '-'
                                : endingDate));
                        },
                        filter: {
                            type: FilterType.DateRange,
                        },
                    },
                    kind: {
                        label: 'Type',
                        toCmp: (kind) => kind,
                        map: (kind) => {
                            return React.createElement("div", null, kind);
                        },
                    },
                    solutionType: {
                        label: 'Løsning',
                        toCmp: (solutionType) => solutionType,
                        map: (solutionType) => {
                            return React.createElement("div", null, solutionType);
                        },
                    },
                    comment: {
                        label: 'Kommentar',
                        toCmp: (comment) => comment,
                        map: (comment) => {
                            return React.createElement("div", null, comment);
                        },
                    },
                }, searchable: true, toSearchStr: (dpt) => JSON.stringify(dpt) })) : (!(h.isError(parkingLotLoadable) || h.isError(parkingLotLoadable)) && (React.createElement(React.Fragment, null,
                React.createElement(PlaceholderLoader, { width: "200px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "120px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "140px" })))))));
};
export default DPT;
//# sourceMappingURL=DPT.js.map